module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Into-The-Badlands-S2.0e451e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Into-The-Badlands-S2.jpg
// module id = i6GN
// module chunks = 0